import { createContext, useContext } from "react";

const ArenaContext = createContext();

export function useArena() {
  return useContext(ArenaContext);
}

export default ArenaContext.Provider;
